export default __webpack_public_path__ + "static/media/unchecked.5fee7611.svg";